<template>
  <div class="ui large modal" ref="modal">
    <i class="close icon"></i>
    <div class="linkify header">
      <i class="exchange alternate icon"></i>
      {{ $t("serbipagos transaction") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/serbipagos.jpg"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui  four item top attached tabular menu" ref="tabs">
          <a class="active item" data-tab="req_params">{{
            $t("request parameters")
          }}</a>
          <a class="item" data-tab="req_xml">{{ $t("request xml") }}</a>
          <a class="item" data-tab="res_params">{{
            $t("response parameters")
          }}</a>
          <a class="item" data-tab="res_xml">{{ $t("response xml") }}</a>
        </div>
        <div
          class="ui bottom attached active tab segment"
          data-tab="req_params"
        >
          <pre>{{ info.request_args }}</pre>
        </div>
        <div class="ui bottom attached tab segment" data-tab="req_xml">
          <pre>{{ info.request }}</pre>
        </div>
        <div class="ui bottom attached tab segment" data-tab="res_params">
          <pre>{{ info.response_args }}</pre>
        </div>
        <div class="ui bottom attached tab segment" data-tab="res_xml">
          <pre>{{ info.response }}</pre>
        </div>

        <!-- <pre>{{ info }}</pre> -->
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";

export default {
  name: "ShortioLinkModalIndex",
  components: {},
  props: { module_configuration: Object },
  computed: {},
  data() {
    return {
      info: {},
      form: undefined,
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data) {
        console.log(data);
        local_api(vm, "post", "/serbipagos/transaction/do-get", {
          u: data.uuid,
        })
          .then((rd) => {
            vm.info = rd;
          })
          .catch((err) => {
            error_toast(err);
          });
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            window
              .jQuery(vm.$refs.tabs)
              .find(".item")
              .tab();
          },
          onHide() {
            // vm.uuid = "";
            // vm.setup = {
            //   name: "",
            //   library: "",
            //   setup: {},
            // };
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          // description: ["empty"],
        },
      });
    },
  },
  mounted() {
    // let vm = this;
    // vm.load_configuration();
  },
  watch: {},
  updated: function() {},
};
</script>
